import { Stack } from 'expo-router';
import { StyleSheet } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import GoBackButton from '@/components/buttons/GoBackButton';
import Title from '@/components/Title';
import PlatformContainer from '@/components/web/PlatformContainer';
import { i18n } from '@/utils/i18n';

const CreateLayout = () => {
  return (
    <PlatformContainer contentCustomClassnames="flex">
      <SafeAreaView style={style.container}>
        <Stack
          screenOptions={{
            headerShadowVisible: false,
            headerBackVisible: false,
            headerLeft: () => <GoBackButton />
          }}>
          <Stack.Screen
            name="volunteerEvent"
            options={{
              headerTitle: () => <Title label={i18n.t('profile.create_event')} />
            }}
          />
          <Stack.Screen
            name="program"
            options={{
              headerTitle: () => <Title label={i18n.t('profile.create_program')} />
            }}
          />
          <Stack.Screen
            name="amenities"
            options={{
              headerTitle: () => <Title label={i18n.t('profile.create_amenity')} />
            }}
          />
          <Stack.Screen
            name="addUpdateAmenity"
            options={{
              headerTitle: () => <Title label={i18n.t('profile.create_amenity')} />
            }}
          />
        </Stack>
      </SafeAreaView>
    </PlatformContainer>
  );
};

const style = StyleSheet.create({
  container: {
    flex: 1
  }
});

export default CreateLayout;
